import { CommonModule } from '@angular/common';
import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, ValidatorFn } from '@angular/forms';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { FormlyModule } from '@ngx-formly/core';
import { QuillConfigModule, QuillEditorComponent } from 'ngx-quill';
import { HelpLabelComponent } from '../help-label/help-label.component';
import { TimeComponent } from '../time/time.component';
import { MatButtonModule } from '@angular/material/button';
import { debounceTime, distinctUntilChanged } from 'rxjs';
import { MatSelectModule } from '@angular/material/select';

type InputType = 'text' | 'checkbox' |'numeric' | 'textarea' | 'time' | 'datepicker' | 'select'

@Component({
    selector: 'app-single-field',
    templateUrl: './single-field.component.html',
    styleUrl: './single-field.component.scss',
    standalone: true,
    imports: [
        CommonModule, ReactiveFormsModule, FormlyModule,

        HelpLabelComponent, TimeComponent, QuillEditorComponent,

        MatSelectModule, MatFormFieldModule, MatInputModule, MatDatepickerModule, MatIconModule, MatSlideToggleModule, MatButtonModule
    ]
})
export class SingleFieldComponent implements OnInit {

    @Output() fieldValueChange: EventEmitter<any> = new EventEmitter()

    @Input() label: string = ""
    @Input() toolTipMsg: string | null = null
    @Input() type: InputType = 'text'
    @Input() options: { name: string; value: string } [] = []
    @Input() deleteSelector: boolean = false

    @Input()
    set validator(pattern: ValidatorFn) {
        this.fieldForm.controls['field'].addValidators(pattern)
    }

    @Input()
    set fieldValue(value: string | boolean | number | null) {
        this.fieldForm.patchValue({ field: value })
    }

    fieldForm!: FormGroup

    constructor(private fb: FormBuilder) {
        this.fieldForm = this.fb.group({ field: [''] })
    }

    ngOnInit(): void {
        if(this.type == 'textarea') {
            this.fieldForm.controls['field'].valueChanges.pipe(debounceTime(400), distinctUntilChanged()).subscribe((data) => {
                this.onBlur(this.fieldForm.get('field')!.value)
            })
        }
    }

    onBlurDatePicker($event?: any) {
        if (this.fieldForm.valid == true && this.fieldForm.dirty == true) {
            let tmpV = this.fieldForm.value
            if (tmpV['field']) {
                const formatted = tmpV['field'].toFormat('yyyy-MM-dd')
                if (this.fieldForm.controls['field'].value !== formatted) {
                    this.fieldForm.controls['field'].setValue(formatted, { emitEvent: false })
                    tmpV = this.fieldForm.value
                }
            }
            this.fieldValueChange.emit(tmpV['field'])
            this.fieldForm.controls['field'].markAsPristine()
        }
    }

    onBlur($event?: any) {
        if (this.fieldForm.valid == true && this.fieldForm.dirty == true) {
            let tmpV = this.fieldForm.value
            this.fieldValueChange.emit(tmpV['field'])
            this.fieldForm.controls['field'].markAsPristine()
        }
    }


    onKeyDown($event: KeyboardEvent) {
        if ($event.key == 'Enter') {
            this.onBlur()
        }
    }

    clearSelection($event: MouseEvent) {
        $event?.stopPropagation();
        const field = this.fieldForm.get('field')
        field?.setValue(null)
        field?.markAsDirty()
        this.onBlur()
    }
    
}
